module.exports = __webpack_public_path__ + "img/prof-lesson.f3accea5.png";